import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance2192nrpo98q6y as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Send_instance3jwyi367vhqvc as Send_instance } from './api/CommonHooks.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_authority2s3hk87lssumy as get_authority } from '../../../../../ktor-ktor-http/io/ktor/http/Url.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { takeFrom3rd40szpqy350 as takeFrom } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { isSecurex1qiiavqi0xu as isSecure } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { get_authorityakhc3pgcrb9j as get_authority_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { Companion_getInstance1pptfj8vjmgsz as Companion_getInstance_0 } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { EventDefinition1fymk8xrdelhn as EventDefinition } from '../../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ALLOWED_FOR_REDIRECT() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return ALLOWED_FOR_REDIRECT;
}
var ALLOWED_FOR_REDIRECT;
function get_LOGGER() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return LOGGER;
}
var LOGGER;
function get_HttpResponseRedirectEvent() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpResponseRedirectEvent;
}
var HttpResponseRedirectEvent;
function get_HttpRedirect() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpRedirect;
}
var HttpRedirect;
var HttpRedirectConfigClass;
function HttpRedirectConfig() {
  if (HttpRedirectConfigClass === VOID) {
    class $ {
      constructor() {
        this.o5p_1 = true;
        this.p5p_1 = false;
      }
    }
    initMetadataForClass($, 'HttpRedirectConfig', HttpRedirectConfig);
    HttpRedirectConfigClass = $;
  }
  return HttpRedirectConfigClass;
}
function isRedirect(_this__u8e3s4) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var tmp0_subject = _this__u8e3s4.w54_1;
  return tmp0_subject === Companion_getInstance().f53_1.w54_1 || tmp0_subject === Companion_getInstance().g53_1.w54_1 || (tmp0_subject === Companion_getInstance().l53_1.w54_1 || (tmp0_subject === Companion_getInstance().m53_1.w54_1 || tmp0_subject === Companion_getInstance().h53_1.w54_1)) ? true : false;
}
function HttpRedirectConfig$_init_$ref_rhym9t() {
  return constructCallableReference(() => new (HttpRedirectConfig())(), 0, 0, 218, '<init>');
}
function HttpRedirect$lambda($this$createClientPlugin) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var checkHttpMethod = $this$createClientPlugin.u5m_1.o5p_1;
  var allowHttpsDowngrade = $this$createClientPlugin.u5m_1.p5p_1;
  var tmp = Send_instance;
  $this$createClientPlugin.x5m(tmp, HttpRedirect$lambda$slambda(checkHttpMethod, allowHttpsDowngrade, $this$createClientPlugin));
  return Unit_instance;
}
function *invoke$handleCall(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
  var call = origin;
  var requestBuilder = context;
  while (true) {
    var previousProtocol = call.r5i().a5j().b56_1;
    var previousAuthority = get_authority(call.r5i().a5j());
    if (!isRedirect(call.t5g().h5j()))
      return call;
    var location = call.t5g().y51().d2o('Location');
    if (location == null) {
      get_LOGGER().a4u('Location header missing from redirect response ' + call.r5i().a5j().toString() + '; returning response as is');
      return call;
    }
    client.m5g_1.e4u(get_HttpResponseRedirectEvent(), call.t5g());
    get_LOGGER().c4u('Received redirect response to ' + location + ' for request ' + call.r5i().a5j().toString());
    // Inline function 'kotlin.apply' call
    var this_0 = new (HttpRequestBuilder())();
    this_0.s5l(requestBuilder);
    this_0.a5i_1.l55_1.s4();
    takeFrom(this_0.a5i_1, location);
    if (!allowHttpsDowngrade && isSecure(previousProtocol) && !isSecure(this_0.a5i_1.o55())) {
      get_LOGGER().c4u('Blocked redirect from ' + call.r5i().a5j().toString() + ' to ' + location + ' due to HTTPS downgrade');
      return call;
    }
    if (!(previousAuthority === get_authority_0(this_0.a5i_1))) {
      this_0.c5i_1.c4q('Authorization');
      get_LOGGER().c4u('Removing Authorization header for cross-authority redirect: ' + (previousAuthority + ' -> ' + this_0.a5i_1.y56()));
    }
    requestBuilder = this_0;
    call = yield* _this__u8e3s4.b5p(requestBuilder, $completion);
  }
}
function HttpRedirect$lambda$slambda($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin) {
  return constructCallableReference(function *($this$on, request, $completion) {
    var origin = yield* $this$on.b5p(request, $completion);
    var tmp;
    if ($checkHttpMethod && !get_ALLOWED_FOR_REDIRECT().t2(origin.r5i().z5i())) {
      return origin;
    }
    return yield* /*#__NOINLINE__*/invoke$handleCall($this$on, request, origin, $allowHttpsDowngrade, $this_createClientPlugin.t5m_1, $completion);
  }, 2);
}
var properties_initialized_HttpRedirect_kt_klj746;
function _init_properties_HttpRedirect_kt__ure7fo() {
  if (!properties_initialized_HttpRedirect_kt_klj746) {
    properties_initialized_HttpRedirect_kt_klj746 = true;
    ALLOWED_FOR_REDIRECT = setOf([Companion_getInstance_0().z51_1, Companion_getInstance_0().e52_1]);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    HttpResponseRedirectEvent = new (EventDefinition())();
    var tmp = HttpRedirectConfig$_init_$ref_rhym9t();
    HttpRedirect = createClientPlugin('HttpRedirect', tmp, HttpRedirect$lambda);
  }
}
//region block: exports
export {
  get_HttpRedirect as get_HttpRedirect1lgx3wewnhrb0,
};
//endregion

//# sourceMappingURL=HttpRedirect.mjs.map
